module.exports = __webpack_public_path__ + "img/20211118.add3b6d2.png";